module.exports = __webpack_public_path__ + "static/media/tune.eaf375f8.svg";